import React from "react";
import "./CompanyAndSharesResult.css";
import { Text, View, Image } from "@react-pdf/renderer";
import { styles } from "../styles/Slide1Styles";
import backgroundImage from "../img/backgroundIntroSlide.png";
import poweredByMace from "../img/PoweredByMace.png";
import { DateTime } from "luxon";
import { Company, CountryType, FoundersType } from "../ResultContext";

export function Slide1({
  foundersResult,
  companyResult,
}: {
  foundersResult: {
    name: string;
    country: CountryType;
    type: FoundersType;
  }[];
  companyResult: Company;
}) {
  function stringBuilder(
    foundersResult: {
      name: string;
      country: CountryType;
      type: FoundersType;
    }[]
  ) {
    let resultString = foundersResult[0].name;
    for (let i = 1; i < foundersResult.length; i++) {
      resultString += ` ft. ${foundersResult[i].name}`;
    }
    return resultString;
  }

  if (!foundersResult || !companyResult) {
    return <Text>Not all information is filled in for this section</Text>;
  }

  if (!foundersResult || !companyResult) {
    return <Text>Not all information is filled in for this section</Text>;
  }

  return (
    <View>
      <Image src={backgroundImage} style={styles.backgroundImage} />
      <View style={styles.content}>
        <View style={styles.titleContainer}>
          <Text style={styles.title}>CO-FOUNDER ALIGNMENT</Text>
        </View>
        <View style={styles.foundersContainer}>
          <Text style={styles.foundersText}>
            {stringBuilder(foundersResult)}
          </Text>
        </View>
        <Image src={poweredByMace} style={styles.poweredImage} />
        <View style={styles.CDContainer}>
          <View style={styles.CDTop}>
            <Text style={styles.CDTopText}>Reliance Restricted</Text>
          </View>
          <View style={styles.CDMiddle}>
            <Text style={styles.CDMiddleText}>{companyResult.name}</Text>
          </View>
          <View style={styles.CDBottom}>
            <Text style={styles.CDBottomText}>
              {DateTime.utc().toFormat("dd/LL/y")}
            </Text>
          </View>
        </View>
      </View>
    </View>
  );
}
